import { injectIntl, defineMessages } from 'react-intl';

import { connect } from 'react-redux';

import ExploreIcon from '@/material-icons/400-24px/explore.svg?react';
import { IconButton } from 'mastodon/components/icon_button';

import { composeFetchLocation } from '../../../actions/compose';

const messages = defineMessages({
  addLocation: { id: 'compose_form.location.add', defaultMessage: 'Use your location' },
});

const mapStateToProps = (state, { intl }) => ({
  iconComponent: ExploreIcon,
  title: intl.formatMessage(messages.addLocation),
  disabled: state.getIn(['compose', 'location_loading']),
  inverted: true,
});

const mapDispatchToProps = dispatch => ({
  onClick () {
    dispatch(composeFetchLocation());
  },
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(IconButton));
